<template>
  <div :class="pageEvent == true ? 'events-color' : 'header'">
    <div class="logo">
      <a href="#/home">
        <div class="imgc">
          <img src="~@/assets/logo-light.png" />
        </div>
      </a>
    </div>
    <div class="nav">
      <ul>
        <li @mouseenter="mouseEnter" @mouseleave="mouseleave">
          <a @click="goTo3d" class="vLine-shadow" :style="{ cursor: 'pointer' }">
            <span @click="goTo3d" class="icon-text models">3D模型</span>
          </a>
          <transition v-if="pageEvent == false" name="fade">
            <div id="navbar-categories-row-container" class="collapse" v-show="isShow">
              <div class="row navbar-categories-row ">
                <div>
                  <h3>热门分类</h3>
                  <div class="_nav_container">
                    <template v-for="(item, index) in navList">
                      <div v-if="index < 20" class="_nav_item" @click="goSearch(item)" :key='index'>
                        {{ item.categoryName }}
                      </div>
                    </template>
                  </div>
                </div>
                <div>

                  <div class="col-md-2 alt">
                    <h3>热门类型</h3>
                    <template v-for="(item, index) in subList">
                      <div v-if="index < 10" class="_nav_item" @click="goSearch(item)" :key="index">
                        {{ item.categoryName }}
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </li>

        <!-- <li>
          <span @click="ktMember">
            <span class="activeTxt">新春特惠购，
              <span v-if="memberState == 0 || state == 0 || homestate == 0">黄金</span>
              <span
                v-else-if="memberState == 1 || state == 1 || state == null || homestate == 1 || homestate == null">开通</span>会员仅需¥99/年</span>
            <span class="activeTxt activeTxt_1">活动截止到2月18日</span>
          </span>
        </li> -->

        <li v-if="$store.state.activityInfo.activityOpen == 1">
          <a @click="goToGfMoney" class="vLine-shadow" :style="{ cursor: 'pointer' }">
            <img src="https://cg-1305238547.cos.ap-beijing.myqcloud.com/assetsimg/hoty.png"
              style="position:absolute;z-index:1005;margin-top: -8px;margin-left: 3px;">
            <span class="icon-text events">领红包</span>
          </a>
        </li>
      </ul>
    </div>

    <div class="fr">
      <div class="login">
        <i @click="goUserCenter" class="el-icon-user-solid icon"></i>
        <el-dropdown v-if="GET_USER_INFO.token">
          <span class="el-dropdown-link" style="color: #ffffff; font-size: 16px">
            {{ GET_USER_INFO.fullName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :class="pageEvent == true ? 'events-header-box-nav' : 'header-box-nav'">
              <span class="fixBlock" @click="goPage('/user/account')">我的账户</span>
            </el-dropdown-item>
            <el-dropdown-item :class="pageEvent == true ? 'events-header-box-nav' : 'header-box-nav'">
              <span class="fixBlock" @click="goPage('/user/resource')">发布资产</span>
            </el-dropdown-item>
            <el-dropdown-item :class="pageEvent == true ? 'events-header-box-nav' : 'header-box-nav'">
              <span class="fixBlock" @click="goPage('/user/myAssets')">我的资产</span>
            </el-dropdown-item>
            <el-dropdown-item :class="pageEvent == true ? 'events-header-box-nav' : 'header-box-nav'">
              <span class="fixBlock" @click="goPage('/user/myDownload')">已购资产</span>
            </el-dropdown-item>
            <el-dropdown-item :class="pageEvent == true ? 'events-header-box-nav' : 'header-box-nav'">
              <span class="fixBlock" @click="goPage('/user/integral')">我的余额</span>
            </el-dropdown-item>
            <el-dropdown-item :class="pageEvent == true ? 'events-header-box-nav' : 'header-box-nav'">
              <span class="fixBlock" @click="goLoginOut">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <span v-else @click="goLogin">登录/注册</span>
      </div>
    </div>

    <div class="fr">
      <div class="cart" @click="goNotice">
        <el-badge :value="bellBadge" :max="99" class="bell-badge">
          <i class="el-icon-bell"></i>
        </el-badge>
      </div>
    </div>

    <!-- 购物车 -->
    <div class="fr">
      <div class="cart" @click="openCart">
        <el-badge :value="cartBadge" :max="99" class="cart-badge">
          <i class="el-icon-shopping-cart-2"></i>
        </el-badge>
      </div>
    </div>
    <!-- vip图标 -->
    <div v-if="memberState == 0 || state == 0 || homestate == 0" class="vipIcon" @click="goMemberBuy">
      <img src="@/assets/member/CVIP.png" alt="">
      <img src="@/assets/member/C_VIP_Logo.png" alt="">
    </div>
    <!-- 不是会员 -->
    <div v-else-if="memberState == 1 || state == 1 || state == null || homestate == 1 || homestate == null"
      class="vipIcon" @click="gonoMemberBuy">
      <img src="@/assets/member/H_VIP.png" alt="">
      <img src="@/assets/member/H_VIP_Logo.png" alt="">
    </div>

    <div class="fr">
      <div class="header-search">
        <input id="NavTextField" type="text" v-model="searchText" autocomplete="off" placeholder="搜索"
          v-on:keyup.enter="searchFun" @change="searchChange" />

        <span class="search-btn" @click="searchFun">
          <img src="~@/assets/icon_search.png" alt />
        </span>
      </div>
    </div>

    <login-modal ref="loginModalRef"></login-modal>
    <openMembership @memberHidden="memberHidden" v-if="isVisible"></openMembership>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { navClassApi } from "@/api/home";
import { noticeNumApi } from "@/api/notice";
import { getCart } from "@/api/extra";
import { getActivityInfo } from "@/api/activity";
import LoginModal from "@/components/LoginModal";
import openMembership from '@/components/openMembership/index.vue'

export default {
  components: { LoginModal, openMembership },
  props: ['memberState', 'homestate'],
  data () {
    return {
      isShow: false,
      searchText: "",
      navList: [],
      subList: [],
      pageEvent: false,
      ModelRandom: false,
      state: null,
      isVisible: false,

    };
  },
  created () {

    this.state = localStorage.getItem('memberState')
    this.getActivity();
    this.getNav();
    this.getSubNav();
    this.getNoticeTotal();
    this.getCartTotal();
    let searchText = localStorage.getItem("searchText");

    if (searchText) {
      this.searchText = searchText;
    } else {
      this.searchText = "";
    }
    if (this.$route.path == "/events" || this.$route.path == "/gfMoney") {
      this.pageEvent = true;
    }
  },

  computed: {
    ...mapGetters(["GET_USER_INFO", "GET_CART_BADGE", "GET_BELL_BADGE", "SET_CHANGERULES_STATE"]),


    cartBadge () {
      return this.GET_CART_BADGE;
    },

    bellBadge () {
      return this.GET_BELL_BADGE;
    },
  },

  methods: {
    ...mapMutations({
      REMOVE_USER_INFO: "REMOVE_USER_INFO",
      SET_CART_VISIBLE: "SET_CART_VISIBLE",
      SET_BELL_BADGE: "SET_BELL_BADGE",
      SET_CART_BADGE: "SET_CART_BADGE",
      SET_CHECKED_LIST: "SET_CHECKED_LIST"


    }),
    getActivity () {
      if (!this.$store.state.activityInfo.id) {
        getActivityInfo().then(res => {
          this.$store.state.activityInfo = res.data
        })
      }
    },
    /**
     * @desc 键盘回车按下或搜索框里的搜索按钮按下
     */
    searchFun () {
      let query = this.searchText;
      localStorage.setItem("emptyRes", 0);
      if (query) {
        localStorage.setItem("searchText", query);
        this.$router.push({
          path: "/search",
          query: {
            name: query,
          },
        });
      } else {
        localStorage.removeItem("searchText");
      }
    },

    async searchChange () {
      if (!this.searchText) {
        localStorage.removeItem("searchText");
      }
    },

    goPage (url) {
      this.$router.push(url);
    },
    goSearch (item) {
      this.$router.push(`/search?categoryId=${item.categoryId}`);
    },
    mouseEnter () {
      this.isShow = true;
    },
    mouseleave () {
      this.isShow = false;
    },
    getNav () {
      const params = {
        type: 1,
        parentId: 1,
        isReturnParent: 0,
        showNum: 25,
      };
      navClassApi(params).then((res) => {
        if (res && res.code === 200) {
          this.navList = res.data;
        }
      });
    },
    goTo3d () {
      this.$router.push("/search");
      this.$parent.categoryName = "3D模型"
      this.$store.commit('SET_CHANGERULES_STATE', false)
    },

    goToGfMoney () {
      this.$router.push("/gfMoney");
    },

    // 打开购物车组件
    openCart () {
      if (this.GET_USER_INFO.token) {
        this.SET_CART_VISIBLE(true);
      } else {
        this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      }
    },
    getSubNav () {
      const params = {
        type: 0,
        parentId: 1,
        isReturnParent: 0,
        showNum: 10,
      };
      navClassApi(params).then((res) => {
        if (res && res.code === 200) {
          this.subList = res.data;
        }
      });
    },
    goUserCenter () {
      if (this.GET_USER_INFO.token) {
        this.$router.push("/user/account");
      }
    },
    /**
     * @desc 点击右上角的登录/注册
     */
    goLogin () {
      if (this.$route.fullPath == '/gfMoney') { // 用户已登录，点击后 使下拉框显示
        this.$refs.loginModalRef.showModal()
      } else { // 没有登录，点击跳转到登录页面
        this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      }
    },
    // 退出
    goLoginOut () {
      this.REMOVE_USER_INFO();
      this.$router.push("/login");
      localStorage.removeItem('memberState')
      this.SET_CHECKED_LIST([])
    },

    // 未读消息数据
    getNoticeTotal () {
      if (this.GET_USER_INFO.token) {
        noticeNumApi({ status: 0 }).then((res) => {
          if (res.code === 200) {
            this.SET_BELL_BADGE(res.data ? res.data : "");
          }
        });
      }
    },

    // 去消息页
    goNotice () {
      if (this.GET_USER_INFO.token) {
        this.$router.push("/user/notice");
      } else {
        this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      }
    },

    // 购物车条数
    getCartTotal () {
      // console.log(this.GET_USER_INFO.token)
      if (this.GET_USER_INFO.token) {
        getCart().then((res) => {
          if (res && res.code === 200) {
            this.SET_CART_BADGE(res.data.length ? res.data.length : "");
          }
        });
      }
    },
    /**
     * @desc 头部vip点击跳转  （不是会员/未登录，图标都是灰色）
     */
    gonoMemberBuy () {
      if (this.GET_USER_INFO.token === '') { // 用户没登录
        this.$router.push({ path: '/member' })
      } else { // 用户已登录      
        this.$router.push({ path: '/memberLogined' })
      }
    },
    goMemberBuy () { // 是会员
      this.$router.push({ path: '/user/account' })

    },
    // ktMember () {
    //   if (this.GET_USER_INFO.token) {
    //     this.isVisible = true
    //   } else {
    //     this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    //   }

    // },
    memberHidden (val) {
      this.isVisible = val
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  height: 50px;
  background-color: #1781b5;
  -webkit-box-shadow: 0 2px 4px rgb(0 0 0 / 50%);
  -moz-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 50%);
  border-radius: 0;
  margin-bottom: 0;
  border: none;
  z-index: 1003;
  position: relative;
}

.events-color {
  height: 50px;
  background-color: #801414;
  -webkit-box-shadow: 0 2px 4px rgb(0 0 0 / 50%);
  -moz-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 50%);
  border-radius: 0;
  margin-bottom: 0;
  border: none;
  z-index: 1003;
  position: relative;
}

.vipIcon {
  float: right;
  width: 100px;
  height: 50px;
  position: relative;
  cursor: pointer;

  img {
    position: absolute;
    width: 48%;
  }

  img:nth-child(1) {
    left: 36px;
    top: 1px;
  }

  img:nth-child(2) {
    width: 30%;
    left: 10px;
    top: 10px;
  }
}

.fr {
  float: right;
}

.newicon {
  width: 25px;
}

.logo {
  float: left;
  height: 50px;
  padding-left: 40px;
  position: relative;

  .a {
    color: #006b9c;
  }

  .imgc {
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    >img {
      //width: auto;
      height: 35px;
      object-fit: contain;
      object-position: right;
      border: none !important;
    }
  }
}

.nav {
  float: left;
  height: 50px;

  >ul {
    display: block;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
    margin-left: unset;

    &:after {
      clear: both;
    }

    >li {
      float: left;
      height: 50px;

      >a {
        color: #fff;
        padding: 13px 10px !important;
        line-height: 20px;

        &:hover {
          color: #ddd;
        }
      }
    }
  }
}

.models {
  border-left: 1px solid #3a545d;
  border-right: 1px solid #3a545d;
}

.icon-text {
  max-height: 24px;
  height: 24px;
  padding: 2px 20px 0 20px;
}

.events {
  padding-right: 35px;
  border-right: 1px solid #3a545d;
}

.member {
  padding-left: 10px;
}

.pixelsquid {
  border-left: 1px solid #3a545d;
  border-right: 1px solid #3a545d;
}

.login {
  color: #fff;
  height: 50px;
  margin-right: 20px;
  cursor: pointer;
  line-height: 50px;
  position: relative;
  padding-left: 30px;

  >i {
    position: absolute;
    font-size: 24px;
    margin-right: 10px;
    top: 13px;
    left: 0;
  }
}

.cart {
  position: relative;
  margin: 13px 20px 0 0;
  width: 24px;
  cursor: pointer;

  i {
    color: #fff;
    // position: absolute;
    // top: 14px;
    // left: 0;
    font-size: 24px;
  }
}

.kraken {
  padding: 2px 0 0 0 !important;
}

#navbar-categories-row-container {
  background-color: #1781b5;
  position: absolute;
  left: 0;
  top: 50px;
  width: 100%;
  z-index: 1002;
  -webkit-box-shadow: 0 2px 4px rgb(0 0 0 / 50%);
  -moz-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 50%);
}

.navbar-categories-row {
  background-color: #1781b5;
  padding: 0;
  margin: 0 auto !important;
  width: 1000px;
  // display: flex;
  position: relative;
  height: 240px;
  overflow: hidden;
}

.navbar-categories-row h3 {
  font-weight: 200 !important;
  font-size: 1.5em;
  margin: 20px 20px 10px !important;
  color: #ff8135;
  text-shadow: none;
  padding: 0 !important;
  line-height: 23.1px;
}

.navbar-categories-row .col-md-2 {
  padding: 0 10px 10px;
  // float: right;
  position: absolute;
  top: 0px;
  width: 360px;
  right: 0;
  bottom: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ._nav_item {
    width: 180px;
    float: left;
    box-sizing: border-box;
    height: 34px;
    display: block;
    font-size: 14px;
    color: #fff;
    padding: 10px 0 10px 20px;
    cursor: pointer;
    box-sizing: border-box;
    margin-bottom: 0px;
  }
}

.navbar-categories-row .col-md-2 a {
  display: block;
  font-size: 14px;
  margin: 10px 0;
  color: #fff;
}

.navbar-categories-row .col-md-2.alt {
  background-color: #15559a;
  padding: 0px;
  font-weight: 700;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

._nav_container {
  width: 640px;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;

  ._nav_item {
    width: 160px;
    box-sizing: border-box;
    display: block;
    font-size: 14px;
    color: #fff;
    padding: 10px 0 10px 20px;
    cursor: pointer;
  }
}

//添加的导航样式

.fixBlock {
  display: block;
  padding: 0 20px;
}

.header-search {
  // height: 100px;
  // background: green;
  margin-top: 10px;
  margin-right: 20px;
  height: 30px;
  border-radius: 3px;
  background-color: rgba(255, 255, 255, 0.95);

  #NavTextField {
    background: 0 0;
    border: none;
    height: 30px;
    width: 200px;
    float: left;
    font-size: 12px;
    padding-left: 13px;
    outline: none;
  }

  .search-btn {
    display: inline-block;
    vertical-align: top;
    // padding-left: 20px;
    width: 30px;
    height: 30px;
    text-align: center;
    cursor: pointer;

    img {
      margin-top: 7px;
      width: 16px;
      height: 16px;
    }
  }
}

/* 网站哀悼日效果 */
// .Box {
//   filter: progid:DXImageTransform.Microsoft.BasicImage(graysale=1);
//   -webkit-filter: grayscale(100%);
// }
</style>

<style lang="less" scoped>
.el-badge__content.is-fixed {
  position: absolute;
  // top: 12px;
  // right: -18px;
  transform: translateY(-50%) translateX(100%);
}

.header-box-nav:not(.is-disabled):hover {
  color: #ffffff;
  background-color: #1781b5;
}

.events-header-box-nav:not(.is-disabled):hover {
  color: #ffffff;
  background-color: #801414;
}

.header-box-nav {
  padding: 0;
}

.activeTxt {
  cursor: pointer;
  color: #FF0808;
  font-size: 18px;
  position: absolute;
  bottom: 16px;
  left: 316px;
  font-weight: bold;
}

.activeTxt_1 {
  font-size: 14px;
  position: absolute;
  bottom: 16px;
  left: 600px;
}
</style>
